import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import * as HelperFunctions from '../../common/functions/helperFunctions';

const UserList = (props) => {

  return (
    <DataTable
      value={props.users}
      paginator={true}
      lazy={true}
      rows={props.rows}
      totalRecords={props.totalRecords}
      onPage={(event) => props.onPageClick(event)}
      first={props.first}
      dataKey='userId'
    //loading={props.isLoading}	
    >
      <Column field="name" header="Name" />
      <Column field="email" header="Email" />
      <Column
        field="lastLogged"
        header="Last logged"
        body={(rowData, column) =>
          <div>
            {rowData.lastLogged ? HelperFunctions.fomatDateTimeAsString(new Date(rowData.lastLogged)) : ""}
          </div>
        }
      />
      <Column
        field="createdOn"
        header="Created on"
        body={(rowData, column) =>
          <div>
            {rowData.createdOn ? HelperFunctions.fomatDateTimeAsString(new Date(rowData.createdOn)) : ""}
          </div>
        }
      />
      <Column
        style={{ textAlign: "center", width: "8em" }}
        field="isActive"
        header="Active"
        body={(rowData, column) =>
          <div>
            <Checkbox
              readOnly={true}
              disabled={true}
              checked={rowData.isActive}
              onChange={() => null}
            />
          </div>
        }
      />
      <Column
        header="Actions"
        style={{ textAlign: "center", width: "8em" }}
        body={(rowData, column) =>
          <div>
            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning"
              tooltip="Edit"
              tooltipOptions={{ position: 'top' }}
              style={{ marginRight: ".5em" }}
              onClick={() => props.editClick(rowData.userId)}
            />
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-danger"
              tooltip="Delete"
              tooltipOptions={{ position: 'top' }}
              onClick={() => props.deleteClick(rowData.userId)}
            />
          </div>
        }
      />
    </DataTable>
  )
}

export default UserList;
